import { useNavigate } from '@solidjs/router'
import { Component, createSignal } from 'solid-js'
import { parse } from 'valibot'
import { backendAxios } from '../../axios'
import AlertBag from '../../components/AlertBag'
import Loader from '../../components/Loader'
import { createAlertBagStore, setAlertBagError, setAlertBagSuccess } from '../../rx/store/AlertBag'
import { StoreMapBodySchema } from '../../backend_schemas'
import blankStateForEngineInit from '../../lib/core/engine/blankStateForEngineInit'
import { saveToDisk } from '../../lib/core/disk/DiskFactory'
import { MAP_DEFAULT_HEIGHT, MAP_DEFAULT_WIDTH } from '../../lib/core/state/StateMap.type'
import { StateMapDisk } from '../../lib/core/state/state_map_disk.enum'
import { getDefaultStateMapDisk } from '../../lib/core/state/getDefaultStateMapDisk'
import createMapEditorPlayer from '../../lib/core/player/createMapEditorPlayer'
import valibotToErrorBag from '../../lib/valibot/valibotToErrorBag'

const CreateMapPage: Component = () => {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = createSignal<boolean>(false)
  const alertBag = createAlertBagStore()

  const handleCreate = async (e: Event) => {
    e.preventDefault()
    setIsLoading(true)
    setAlertBagError(alertBag, null)
    try {
      // Create a proper state object for a new map
      const state = blankStateForEngineInit()

      // Set default dimensions and add second player to meet validation requirements
      state.width = MAP_DEFAULT_WIDTH
      state.height = MAP_DEFAULT_HEIGHT
      state.players.push(createMapEditorPlayer(state, state.rng))

      // Set disk type based on default
      const defaultDisk = getDefaultStateMapDisk()
      state.map.disk = defaultDisk
      if (defaultDisk === StateMapDisk.IndexedDB) {
        state.online = null
      }

      const payload = parse(StoreMapBodySchema, { state })

      // Save to appropriate disk
      let mapId: number
      const diskType = state.map.disk
      if (diskType === StateMapDisk.IndexedDB) {
        const response = await saveToDisk(state, StateMapDisk.IndexedDB)
        mapId = response.id
      } else {
        const response = await backendAxios.post('/st1/map', payload)
        mapId = response.data.id
      }

      setAlertBagSuccess(alertBag, 'Map created successfully')
      navigate(`/maps/edit?map_id=${mapId}&disk=${diskType}`)
    } catch (err) {
      console.log(valibotToErrorBag(err))
      console.error(err)
      setAlertBagError(alertBag, err as Error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div class="container mt-5">
      <h2>Create Map</h2>
      <AlertBag store={alertBag} />
      <form onSubmit={handleCreate}>
        <button type="submit" class="btn btn-primary" disabled={isLoading()}>
          {isLoading() ? <Loader /> : 'Create Map'}
        </button>
      </form>
    </div>
  )
}

export default CreateMapPage
